// @flow
import React, {type Node, useEffect, useRef} from 'react';
import styled from 'styled-components';

type Props = {|
  children: Node,
  dataTestName: string,
  setIsOpen: (boolean) => void,
|};

export default function DropdownSelect({
  children,
  dataTestName,
  setIsOpen,
}: Props): Node {

  const dropdownRef = useRef(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <Wrapper ref={dropdownRef} name={`${dataTestName}_dropdown`}>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;
